.container {
  margin: 0;
  padding: 0;
}

.item {
  list-style-type: none;
  line-height: 125%;
}
